// extracted by mini-css-extract-plugin
export default {"user":"app_user__gluEo","userInfo":"app_userInfo__bUgd0","userName":"app_userName__Xjipr","userRole":"app_userRole__oHZ9n color1"};